module.exports = __webpack_public_path__ + "img/restaurant_bodyimage01.5122091f.jpg";